"use client";

import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheSashaLandonExperience() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="229803" id="the-petit-lab-studio" className="dark bg-background text-foreground relative overflow-hidden py-20 lg:py-32">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-primary/10 blur-[120px] pointer-events-none rounded-full" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center">
          
          {}
          <div ref={imageRef} className={`relative aspect-[4/5] lg:aspect-[3/4] w-full max-w-md mx-auto lg:max-w-none overflow-hidden rounded-3xl shadow-3xl transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            {}
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1643032/img/3d-printer-heart-toy.png" alt="3D Printed Heart Toy Illustration" className="absolute inset-0 w-full h-full object-cover contrast-110 brightness-105" />
            {}
            <div className="absolute inset-0 border border-primary/20 rounded-3xl pointer-events-none mix-blend-overlay" />
            <div className="absolute inset-0 bg-gradient-to-t from-secondary/40 via-transparent to-transparent" />
          </div>

          {}
          <div ref={contentRef} className={`flex flex-col justify-center transition-all duration-1000 delay-200 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="flex items-center gap-2 mb-6">
              <Sparkles className="size-5 text-chart-3" />
              <span className="text-chart-3 font-default tracking-widest uppercase text-sm font-semibold">
                Custom Creations
              </span>
            </div>

            <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold mb-8 leading-tight text-foreground">
              The Petit Lab: <br className="hidden lg:block" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-chart-3">
                Your Dream, 3D Printed
              </span>
            </h2>

            <div className="space-y-6 text-muted-foreground text-lg font-default leading-relaxed mb-10">
              <p>
                Step into a world where Kawaii aesthetics meet high-precision 3D printing. As the creative heart of Petit Pop Toys, our Petit Lab in Quebec brings your wildest fidget obsessions to life with boutique quality and French-inspired flair.
              </p>
              <p>
                This is more than just a toy; it's a piece of collectible art designed specifically for you. From vibrant sports themes to sweet treats, we craft bespoke fidgets that are as fashionable as they are functional.
              </p>
            </div>

            <div>
              <Link to="#">
                <Button variant="outline" size="lg" className="relative overflow-hidden bg-chart-3 border-chart-3 text-white hover:bg-chart-3/90 hover:scale-105 active:scale-95 transition-all duration-500 group h-14 px-10 rounded-full shadow-lg shadow-chart-3/20">
                  {}
                  <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent group-hover:translate-x-full transition-transform duration-1000 ease-in-out" />
                  
                  <span className="relative flex items-center gap-3 font-default tracking-wide text-base font-semibold">
                    Start Your Custom Order
                    <ArrowRight className="size-5 transition-transform duration-300 group-hover:translate-x-1 text-white" />
                  </span>
                </Button>
              </Link>
            </div>
          </div>

        </div>
      </div>
    </section>;
}